export interface FamilyDetail {
  id: any;
  relation: number;
  relationName: string;
  name: string;
  gender: number;
  genderName: string;
  dob: string;
}
 
type EmployerDetailKey = keyof FamilyDetail;
interface EmployerDetailHeader1 {
  key: EmployerDetailKey;
  label: string;
  modifier?:any
}
export const FamilyDetailHeaders: EmployerDetailHeader1[] = [
  { key: "relationName", label: "Relation" },
  { key: "name", label: "Name" },
  { key: "genderName", label: "Gender" },
  { key: "dob", label: "Date Of Birth",  },
];

const formatDate = (date: string | Date | undefined): string | undefined => {
  if (!date) return undefined;
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
 
 
 